import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function SubscriptionExpired() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div className="expired-screen">
      <div style={{ textAlign: 'center', color: 'white', padding: '32px', maxWidth: '500px' }}>
        <div style={{ fontSize: '80px', marginBottom: '20px' }}>⏰</div>
        <h1 style={{ fontFamily: 'Syne', fontSize: '32px', color: 'var(--accent)', marginBottom: '12px' }}>
          Subscription Expire Ho Gaya
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '16px', lineHeight: 1.8, marginBottom: '32px' }}>
          Aapka BarberHub subscription khatam ho gaya hai.<br/>
          App dobara use karne ke liye admin se rabta karein<br/>
          aur subscription renew karaein.
        </p>
        <div style={{ background: 'rgba(255,255,255,0.05)', borderRadius: '12px', padding: '20px', marginBottom: '32px' }}>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '13px', marginBottom: '8px' }}>Admin se rabta karein:</p>
          <a href="https://wa.me/923001234567" style={{ color: 'var(--gold)', fontSize: '18px', fontWeight: 700, textDecoration: 'none' }}>
            📲 WhatsApp pe Message Karein
          </a>
        </div>
        <button onClick={handleLogout} className="btn btn-outline" style={{ borderColor: 'rgba(255,255,255,0.3)', color: 'rgba(255,255,255,0.7)' }}>
          Logout
        </button>
      </div>
    </div>
  );
}
